import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation, Form } from "react-router-dom";
import axiosInstance from "../../../../lib/axios";

import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import {
  Delete as DeleteIcon,

  RowingRounded,
} from "@mui/icons-material";
import useInitialRender from "../../../../hooks/useInitialRender";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import { getFormMode } from "../../../../lib/helpers";
import CustomAutoCompleteNew from "../../../AutoComplete/CustomAutoCompleteNew";
import CustomAutocomplete from "../../../AutoComplete/AutocompletewithoutIcon";
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";

const FORM_MODE = getFormMode();
const INIT_STATE = {
  TktCategoryId: "",
  PropId: "",
  ServiceProvId: "",
};

const columns = [
  { id: "TktCategoryName", label: "CategoryName", minWidth: 100 },
  { id: "PropName", label: "Property", minWidth: 100 },

];

const PropWiseCatAllocation = () => {
  const navigate = useNavigate();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [categories, setcategories] = useState([]);
  const location = useLocation();
  const [currentPropId, setCurrentPropId] = useState(() => {
    if (location.state && location.state?.PropId) {
      return location.state && location.state?.PropId;
    }
  });
  const [form, setForm] = useState({ ...INIT_STATE, PropId: location?.state?.PropId || "" });

  const [mode, setMode] = useState(() =>
    currentPropId ? FORM_MODE.read : FORM_MODE.add
  );
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const [Status, setStatus] = useState("1");
  const [properties, setProperties] = useState([]);

  const [editRowId, setEditRowId] = useState(null);
  const [entryToDelete, setEntryToDelete] = useState(null);
  const [isRefCategory, setIsRefCategory] = useState(false);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);

  const [newlyAddedIds, setNewlyAddedIds] = useState(new Set());
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });


  // ----- NEW: Category allocation dialog -----
  const [catDialogOpen, setCatDialogOpen] = useState(false);
  const [selectedCats, setSelectedCats] = useState({}); // { [catId]: true/false }

  const RequiredLabel = ({ label }) => (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '2px' }}>
      <span style={{ color: 'red', fontSize: '1rem' }}>*</span>
      <span style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
    </div>
  );

  const toggleCategory = (catId) => {
    setSelectedCats((prev) => ({
      ...prev,
      [String(catId)]: !prev[String(catId)], // Ensure string key
    }));
  };

  const confirmSelectedCategories = () => {
    if (!form.PropId) {
      toast.error("Please select a property first.");
      return;
    }

    // Get currently selected category IDs (from checkboxes)
    const selectedCatIds = Object.keys(selectedCats)
      .filter((id) => selectedCats[id])
      .map(String);

    // Build new rows ONLY from selected categories
    const newRows = selectedCatIds
      .map((catId) => {
        const cat = categories.find((c) => String(c.Id) === catId);
        if (!cat) return null;

        // Use a stable temp ID (or real Id if exists later)
        const tempId = `temp_${form.PropId}_${catId}`;

        const propName = properties.find((p) => p.Id === form.PropId)?.Name || "";

        return {
          Id: tempId,
          PropId: form.PropId,
          PropName: propName,
          TktCategoryId: catId,
          TktCategoryName: cat.Name || "",
        };
      })
      .filter(Boolean);

    // Replace entire rows with only the selected ones
    setRows(newRows);

    // Update newly added IDs (for future tracking if needed)
    setNewlyAddedIds(new Set(newRows.map((r) => r.Id)));

    // Close dialog and reset selection
    setCatDialogOpen(false);
    setSelectedCats({});
    // toast.success("Categories updated successfully!");
  };


  const openCatDialog = () => {
    if (!form.PropId) {
      toast.error("Please select a property first.");
      return;
    }

    // Pre-check categories that are currently in the table
    const preChecked = {};
    rows.forEach((row) => {
      if (row.TktCategoryId) {
        preChecked[String(row.TktCategoryId)] = true;
      }
    });
    setSelectedCats(preChecked);
    setCatDialogOpen(true);
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        PropId: 1,
        WardenId: 1,
        ServiceProvId: 1,
        TktCategoryId: 1,
        Flag: "Dash",
      };

      try {
        const res = await axiosInstance.post('TktCategory/GetMstPropWiseServProDashBoard', { params });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  useEffect(() => {
    const fetchPropertyDrp = async () => {
      try {
        const response = await axiosInstance.post(
          "PropertyMst/GetPropertyMstUserwisedrp",
          {
            Flag: "",
            UserId: UserId,
          }
        );
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data)) {
          setProperties(Data);
          if (mode === FORM_MODE.add || mode === FORM_MODE.edit) {
            if (currentPropId) {
              setForm((prevData) => ({
                ...prevData,
                PropId: currentPropId,
              }));
            } else if (Data.length > 0) {
              setForm((prevData) => ({
                ...prevData,
                PropId: Data[0].Id,
              }));
            }
          }
        }
      } catch (error) {
        return error;
      }
    };
    fetchPropertyDrp();
  }, []);
  //catrgory drp
  useEffect(() => {
    const fetchCategoryName = async () => {
      try {
        const response = await axiosInstance.get(
          `TktCategory/getTktCategorydrp`
        );
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
          setcategories(Data);
          if (Data.length > 0) {
            setForm((prevData) => ({
              ...prevData,
              TktCategoryId: Data[0]?.TktCategoryId || "",
            }));
          }
        } else {
          setcategories([]);
          setForm((prevData) => ({
            ...prevData,
            TktCategoryId: "",
          }));
        }
      } catch (error) {
        console.error("Error fetching CategoryName. Please try again.", {
          autoClose: 1000,
        });
      }
    };
    fetchCategoryName();
  }, []);


  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {

    fetchCategoryData(form.PropId);
  }, [form.PropId]);

  const fetchCategoryData = async (propId) => {
    try {
      const response = await axiosInstance.post(
        `TktCategory/GetMstPropWiseServProDashBoard`,
        {
          PropId: propId,
          WardenId: 1,
          ServiceProvId: 1,
          TktCategoryId: 1,
          Flag: "DashR",
        }
      );
      const {
        data: { Status, Message, Data, responseStatusCode },
      } = response;

      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        const data = Data[0];
        setRows(Data);
        if (!form.PropId) {
          setForm((prevData) => ({
            ...prevData,
            PropId: data.PropId,
          }));
        }
      } else {
        console.error("Failed to fetch warden allocation data");
        setRows([]);
      }
    } catch (error) {
      console.error("Error fetching warden master data:", error);
    }
  };

  const handleDelete = () => {
    setOpenConfirmDialog(true);
  };
  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    const propIdToUse = form.PropId || currentPropId;

    const payload = {
      PropId: propIdToUse,
      TktCategoryId: 1,
    };

    if (!payload.PropId) {

      toast.error("PropId is missing or invalid");
      return;
    }
    try {
      const response = await axiosInstance.post(
        "TktCategory/DeleteMstCatWiseProp",
        payload
      );
      const {
        data: { Status, Message },
      } = response;
      if (Status === 0 && Message) {
        toast.success(Message);
        await fetchCategoryData(propIdToUse);
      }
    } catch (error) {
      console.error("Error deleting entry:", error);
    }
  };

  const handlePrevious = () => { };
  const handleNext = () => { };

  const handleEdit = () => {
    setMode(FORM_MODE.edit);
  };
  useEffect(() => {
    console.log("Form state updatednew:", form);
  }, [form]);

  const handleAdd = () => {
    setMode(FORM_MODE.add);
    setForm((prevData) => {
      const newState = {
        ...INIT_STATE,
        PropId: form.PropId,
      };

      return newState;
    });
  };

  const handleCancel = async () => {
    setMode(FORM_MODE.read);
  };

  const handleExit = () => {
    navigate("/property-wise-category-allocation-table");
  };

  const handleSubmit = async () => {

    if (rows.length === 0) {
      toast.error("No data for Submit.", {
        autoClose: 1000,
      });
      return;
    }


    const result = {
      PropWiseServProConfig: rows.map((row) => ({
        PropId: row.PropId,
        WardenId: 1,
        TktCategoryId: row.TktCategoryId,
        AltWardenId: 1,
        ServiceProvId: 1,
      })),
    };

    let jsonData = JSON.stringify(result);
    jsonData = jsonData.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    jsonData = '"' + jsonData + '"';

    try {
      const response = await axiosInstance.post(
        "TktCategory/ManageMstCatWiseProp",
        jsonData
      );

      const {
        data: { Status, Message },
      } = response;

      if (Status === 0) {
        toast.success(Message, { autoClose: 1000 });
        setMode(FORM_MODE.read);
        setIsFormDisabled(true);
        setForm((prevData) => ({
          ...prevData,
          TktCategoryId: "",
        }));
        setEditRowId(null);
      } else {
        console.error(Message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error adding :", error);
    }
  };

  const handleDeleteIndividual = async (entry) => {
    try {
      // Perform API call to delete the specific row
      const response = await axiosInstance.post(
        "TktCategory/DeleteMstCatWiseProp",
        {
          PropId: entry.PropId,
          TktCategoryId: entry.TktCategoryId,
        }
      );
      const {
        data: { Status, Message },
      } = response;
      if (Status === 0 && Message) {
        toast.success(Message);
        // Update rows state to remove the specific row
        setRows((prevRows) =>
          prevRows.filter((row) => row.Id !== entry.Id)
        );

      } else {
        toast.error(Message);
      }
    } catch (error) {
      console.error("Error deleting entry:", error);
    }
  };


  return (
    <>
      <ToastContainer />
      <Box className="form-container"
        sx={{
          width: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          maxWidth: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          overflowX: "hidden",
          overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
        }}
      >

        <Grid container spacing={2}
          sx={{
            width: { xs: "93%", sm: "80%", md: "80%" },
            height: 'auto',
            margin: 'auto',
            marginTop: { xs: "60px", sm: 0, md: 'auto' },
            marginBottom: { xs: "110px", sm: 0, md: 'auto' },
            borderRadius: '8px',
            padding: { xs: '0px 5px 5px 5px', sm: '0px 20px 20px 20px' },  // Responsive padding: full left/right on mobile, as per original on larger screens
            backgroundColor: '#fff',
          }}>

          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              marginInline: "0px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid sx={{
              textAlign: { xs: "center", sm: "left" }, // Center heading on xs, left-align on sm and up
              width: "100%", // Ensures the grid takes up full width to center properly
            }}>
              <Typography variant="h5">Property Wise Category Allocation</Typography>
            </Grid>
            <Grid>
              <CrudButtons
                moduleName="Property Wise Category Allocation"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onView={handlePrint}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === FORM_MODE.read}
              />
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            className="form_field"
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: "800px", width: "100%" }}
            >
              <Grid item xs={12} md={6}>
                <CustomAutocomplete
                  id="propId-select"
                  name="PropId"
                  options={properties}
                  value={properties.find((property) => property.Id === form.PropId) || null}
                  onChange={handleInputChange}
                  label={
                    <span>
                      Select Property <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  disabled={mode === FORM_MODE.read}
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{
                textAlign: { xs: "center", sm: "left" },
                width: "100%",
              }}>
                <Button
                  variant="contained"
                  onClick={openCatDialog}
                  disabled={mode === FORM_MODE.read || !form.PropId}
                >
                  Allocate Category
                </Button>
              </Grid>

              <Grid item xs={12}>
                <TableContainer
                  component={Paper}
                  sx={{
                    maxHeight: { xs: '300px', sm: '200px', md: '200px' },
                    overflowY: "auto",
                    boxShadow: 3,
                    borderRadius: 2,
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#e8f5e9",
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #c8e6c9",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Property
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#e8f5e9",
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #c8e6c9",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Category
                        </TableCell>

                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#e8f5e9",
                            textAlign: "left",
                            padding: "12px",
                            borderBottom: "1px solid #c8e6c9",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.length === 0 ? (
                        <TableRow>
                          <TableCell
                            colSpan={6}
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Typography
                                variant="h6"
                                style={{ color: "#555" }}
                              >
                                No Data Found...
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ) : (
                        Array.isArray(rows) &&
                        rows.map((row, index) => (
                          <TableRow
                            key={row.Id}
                            sx={{
                              "&:hover": { backgroundColor: "#f1f8e9" },
                              transition: "background-color 0.3s ease",
                              backgroundColor: row.Id === editRowId ? "#e3f2fd" : "inherit",
                            }}
                          >
                            <TableCell
                              sx={{
                                padding: "5px",
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                color: "#333",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                            >
                              {row.PropName}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "5px",
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                color: "#333",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                            >
                              {row.TktCategoryName}
                            </TableCell>

                            <TableCell
                              sx={{
                                padding: "5px",
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                color: "#333",
                                display: "flex",
                                justifyContent: "space-around",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                            >

                              <DeleteIcon
                                sx={{
                                  margin: "0px 0px 0px 0px",
                                  color:
                                    mode === FORM_MODE.read
                                      ? "gray"
                                      : "inherit",
                                  cursor:
                                    mode === FORM_MODE.read
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onClick={
                                  mode !== FORM_MODE.read
                                    ? () => handleDeleteIndividual(row)
                                    : undefined
                                }
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            className="form_button"
            style={{
              marginTop: "10px",
              marginBottom: { xs: '10px', sm: '0px', md: "0px" }
            }}
          >
            {mode === FORM_MODE.read && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #635bff, #635bff)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #635bff, #635bff)",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box >

      {/* ---------- CATEGORY ALLOCATION DIALOG ---------- */}
      {/* <Dialog open={catDialogOpen} onClose={() => setCatDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Select Categories to Allocate</DialogTitle>
        <DialogContent dividers sx={{ maxHeight: "60vh" }}>
          <FormGroup>
            {categories.map((cat) => (
              <FormControlLabel
                key={cat.Id}
                control={
                  <Checkbox
                    checked={!!selectedCats[String(cat.Id)]}
                    onChange={() => toggleCategory(String(cat.Id))}
                  />
                }
                label={cat.Name}
              />
            ))}
          </FormGroup>
          {categories.length === 0 && (
            <Typography align="center" color="textSecondary">
              No categories available
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={confirmSelectedCategories}
            disabled={!Object.values(selectedCats).some((v) => v)}
          >
            Confirm
          </Button>
          <Button onClick={() => setCatDialogOpen(false)}>Cancel</Button>

        </DialogActions>
      </Dialog> */}
      {/* ---------- CATEGORY ALLOCATION DIALOG ---------- */}
      <Dialog
        //  open={catDialogOpen} onClose={() => setCatDialogOpen(false)} maxWidth="sm" fullWidth
        open={catDialogOpen}
        onClose={(event, reason) => {
          // Prevent closing on backdrop click or Escape key
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          setCatDialogOpen(false);
          setSelectedCats({});
        }}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown={true}
        BackdropProps={{
          style: { pointerEvents: 'none' } 
        }}
        PaperProps={{
          style: { pointerEvents: 'auto' } 
        }}
      >
        <DialogTitle>Select Categories to Allocate</DialogTitle>
        <DialogContent dividers sx={{ maxHeight: "60vh" }}>
          <FormGroup>
            {/* ===== SELECT ALL CHECKBOX (FIXED) ===== */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={categories.length > 0 && categories.every(cat => selectedCats[String(cat.Id)])}
                  indeterminate={
                    categories.length > 0 &&
                    categories.some(cat => selectedCats[String(cat.Id)]) &&
                    !categories.every(cat => selectedCats[String(cat.Id)])
                  }
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const allSelected = {};
                    categories.forEach((cat) => {
                      allSelected[String(cat.Id)] = checked;
                    });
                    setSelectedCats(allSelected);
                  }}
                />
              }
              label={<Typography fontWeight="bold">All</Typography>}
              sx={{ mb: 1, borderBottom: '1px solid #e0e0e0', pb: 1 }}
            />

            {/* ===== INDIVIDUAL CATEGORY CHECKBOXES ===== */}
            {categories.map((cat) => (
              <FormControlLabel
                key={cat.Id}
                control={
                  <Checkbox
                    checked={!!selectedCats[String(cat.Id)]}
                    onChange={() => toggleCategory(String(cat.Id))}
                  />
                }
                label={cat.Name}
              />
            ))}
          </FormGroup>

          {categories.length === 0 && (
            <Typography align="center" color="textSecondary">
              No categories available
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={confirmSelectedCategories}
          //disabled={!Object.values(selectedCats).some((v) => v)}
          >
            Confirm
          </Button>
          <Button
            onClick={() => {
              setCatDialogOpen(false);
              setSelectedCats({});
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <div style={{ display: 'none' }}>
        {rows.length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Service Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: '#f5f5f5' }}
          />
        )}
      </div>
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PropWiseCatAllocation;